import React, { useRef, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';

const HeroSlider = () => {
  const carouselRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);

  const handleDragStart = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;

    const diff = e.clientX - startX;
    if (Math.abs(diff) > 50) {
      // Threshold to avoid accidental swipes
      if (diff > 0) {
        // Dragging to the right, go to the previous slide
        carouselRef.current.prev();
      } else {
        // Dragging to the left, go to the next slide
        carouselRef.current.next();
      }
      setIsDragging(false); // Reset dragging after the slide action
    }
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  const images =[
    "https://9wicket.pro:3002/photos_1732820391122.webp",
    "https://9wicket.pro:3002/photos_1732820795037.webp",
    "https://9wicket.pro:3002/photos_1732820456951.webp",
    "https://9wicket.pro:3002/photos_1732820483158.webp",
    "https://9wicket.pro:3002/photos_1732826547734.webp",
    "https://9wicket.pro:3002/photos_1732820510686.webp",
    "https://9wicket.pro:3002/photos_1732820521815.webp"
  ]

  return (
    <div
      onMouseDown={handleDragStart}
      onMouseMove={handleDragMove}
      onMouseUp={handleDragEnd}
      onMouseLeave={handleDragEnd} // Handle drag ending if mouse leaves the carousel
      className=' '
    >
      <Carousel ref={carouselRef} className="container">
        {images.map((image)=><Carousel.Item>
          <img src={image} alt="" className=' object-cover w-full h-[140px] rounded-lg' />
        </Carousel.Item>)} 
      </Carousel>
    </div>
  );
};

export default HeroSlider;
